import React,{useState,useEffect,useRef,}from 'react'
import { Modal,message,Form,DatePicker, InputNumber, Input,} from 'antd';
import { useShangpingdingdanUpdateQuery, useShangpingdingdanUpdateSaveMutation } from '../../store/ReactWebSiteApi';
import dayjs from 'dayjs';
import GetWebGoods from '../goods/GetWebGoods';
import GetWebGoodsSpec from '../goodsSpec/GetWebGoodsSpec';
import ClientSelect from '../client/ClientSelect';
import MyEditor from '../../cpn/MyEditor';
import WebGoodsTypeSelect from '../goodsType/WebGoodsTypeSelect';
import SonTypeSelect from '../goodsType/SonTypeSelect';
function WebGoodsOrderEdit(props) {
    const [form] = Form.useForm();           
    const [open, setOpen] = useState(false);
    const [info,setInfo] = useState({dd_eowg_id:""});
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        let arr = []
        for (let propName in values) {
            if(propName.includes('subType')){
                arr.push(values[propName])
            }     
        }
        submitUpdateSave({
            'dd_eowgt_id': info.dd_eowgt_id,
            'dd_eowgt_name': info.dd_eowgt_name,
            'dd_eowgts_id': info.dd_eowgts_id,
            'dd_eowgts_name': info.dd_eowgts_name,
            'dd_eowg_id': info.dd_eowg_id,
            'dd_eowg_name': info.dd_eowg_name,
            'dd_eowgg_id': info.dd_eowgg_id,
            'dd_eowgg_name': info.dd_eowgg_name,
            'dd_byxkh_id': info.dd_byxkh_id,
            'dd_byxkh_name': info.dd_byxkh_name,
            'dd_xf_date': info.dd_xf_date,
            'dd_dq_date': info.dd_dq_date,
            'dd_xf_amount': info.dd_xf_amount,
            'dd_xf_num': info.dd_xf_num,
            'dd_content': info.dd_content,
            'dd_qy_id': info.dd_qy_id,
            'dd_qy_name': info.dd_qy_name,
            'dd_database': info.dd_database,
            'dd_uid': localStorage.getItem('eu_id'),
            'dd_uname': localStorage.getItem('eu_name'),
            dd_id:props.dd_id
        }).then((res) => {
            // console.log(res);
            if (res.data.Status === 'success') {
                message.success('修改成功！')   
                setOpen(false)                             
            }
            if (res.data.Status === 'fail') {
                message.error('修改失败！'+res.data.Message)
            }
        })
        setOpen(false);
    };   
    const editForm = useRef()
    const {data,isSuccess} = useShangpingdingdanUpdateQuery({dd_id:props.dd_id},{skip:!open})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                editForm.current.setFieldsValue({
                    dd_eowg_id:data.Result.dd_eowg_name,
                    dd_eowgg_id:data.Result.dd_eowgg_name,
                    dd_byxkh_id:data.Result.dd_byxkh_name,
                    dd_xf_amount:data.Result.dd_xf_amount,
                    dd_xf_num:data.Result.dd_xf_num,
                    dd_content:data.Result.dd_content,
                    dd_qy_id:data.Result.dd_qy_id,
                    dd_qy_name:data.Result.dd_qy_name,
                    dd_database:data.Result.dd_database,
                    dd_xf_date:dayjs(data.Result.dd_xf_date),
                    dd_dq_date:dayjs(data.Result.dd_dq_date),
                    dd_eowgt_id:data.Result.dd_eowgt_id,
                    dd_eowgt_name:data.Result.dd_eowgt_name,
                    dd_eowgts_id:data.Result.dd_eowgts_id,
                    dd_eowgts_name:data.Result.dd_eowgts_name,
                })
                setInfo(prevState=>({...prevState,
                    dd_eowg_id:data.Result.dd_eowg_id,
                    dd_eowg_name:data.Result.dd_eowg_name,
                    dd_eowgg_id:data.Result.dd_eowgg_id,
                    dd_eowgg_name:data.Result.dd_eowgg_name,
                    dd_byxkh_id:data.Result.dd_byxkh_id,
                    dd_byxkh_name:data.Result.dd_byxkh_name,
                    dd_xf_amount:data.Result.dd_xf_amount,
                    dd_xf_num:data.Result.dd_xf_num,
                    dd_content:data.Result.dd_content,
                    dd_xf_date:data.Result.dd_xf_date,
                    dd_dq_date:data.Result.dd_dq_date,
                    dd_qy_id:data.Result.dd_qy_id,
                    dd_qy_name:data.Result.dd_qy_name,
                    dd_database:data.Result.dd_database,
                    dd_eowgt_id:data.Result.dd_eowgt_id,
                    dd_eowgt_name:data.Result.dd_eowgt_name,
                    dd_eowgts_id:data.Result.dd_eowgts_id,
                    dd_eowgts_name:data.Result.dd_eowgts_name,
                }))
                
            }
        }
    },[data,isSuccess])
    const [submitUpdateSave] = useShangpingdingdanUpdateSaveMutation()
   
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                open={open}
                title='修改商品'
                okText="提交"
                cancelText="取消"
                width={1200}
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                    
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_client_edit_${props.dd_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 2 }}
                    ref={editForm}
                >
                    <WebGoodsTypeSelect
                        label='商品类型'
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,dd_eowgt_id:e,dd_eowgt_name:f}))
                        }}
                        wrapperCol={{span:10}} 
                        required
                        name='dd_eowg_type_id'

                    />
                    <SonTypeSelect
                        label='系统名称'
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,dd_eowgts_id:e,dd_eowgts_name:f}))
                        }}
                        wrapperCol={{span:10}} 
                        required
                        name='dd_eowgts_id'
                        eowgt_id={info.dd_eowgt_id}
                    />
                    <GetWebGoods
                        label='商品'
                        onChange={(e,f) => {setInfo(prevState=>({...prevState,dd_eowg_id:e,dd_eowg_name:f}))}}
                        wrapperCol={{span:10}} 
                        required
                        name='dd_eowg_id'
                    />
                    <GetWebGoodsSpec
                        label='商品规格'
                        onChange={(e,f) => {setInfo(prevState=>({...prevState,dd_eowgg_id:e,dd_eowgg_name:f}))}}
                        wrapperCol={{span:10}} 
                        required
                        eowgg_eowg_id={info.dd_eowg_id}
                        name='dd_eowgg_id'
                    />
                    <ClientSelect
                        label='客户'
                        onChange={(e,f) => {setInfo(prevState=>({...prevState,dd_byxkh_id:e,dd_byxkh_name:f,dd_qy_id:e,dd_qy_name:f}))}}
                        wrapperCol={{span:10}} 
                        required
                        name='dd_byxkh_id'
                    />
                    <Form.Item name="dd_xf_date" label='缴费日期' wrapperCol={{span:10}} required>
                        <DatePicker
                            onChange={(e) => {setInfo(prevState=>({...prevState,dd_xf_date:dayjs(e).format('YYYY-MM-DD')}))}}
                        />
                    </Form.Item>
                    <Form.Item name="dd_dq_date" label='到期日期' wrapperCol={{span:10}} required>
                        <DatePicker
                            onChange={(e) => {setInfo(prevState=>({...prevState,dd_dq_date:dayjs(e).format('YYYY-MM-DD')}))}}
                        />
                    </Form.Item>
                    <Form.Item name="dd_xf_amount" label='缴费金额' wrapperCol={{span:10}} required>
                        <InputNumber  onChange={(e) => {setInfo(prevState=>({...prevState,dd_xf_amount:e}))}}/>
                    </Form.Item>
                    <Form.Item name="dd_xf_num" label='用户数' wrapperCol={{span:10}} required>
                        <InputNumber  onChange={(e) => {setInfo(prevState=>({...prevState,dd_xf_num:e}))}}/>
                    </Form.Item>
                    <Form.Item name="dd_qy_id" label='企业id' wrapperCol={{span:10}} required>
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,dd_qy_id:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item label='企业名称' wrapperCol={{span:10}} required  name="dd_qy_name">
                        <Input  
                            placeholder="请输入企业名称"
                            value={info.dd_qy_name || ''}
                            onChange={(e) => {setInfo(prevState=>({...prevState,dd_qy_name:e.target.value}))}} 
                        />
                    </Form.Item>
                    <Form.Item name="dd_database" label='数据库' wrapperCol={{span:10}} required>   
                        <Input  onChange={(e) => {setInfo(prevState=>({...prevState,dd_database:e.target.value}))}}/>
                    </Form.Item>
                    <Form.Item name="dd_content" label='备注' wrapperCol={{span:10}}>
                        <MyEditor  onChange={(e) => {setInfo(prevState=>({...prevState,dd_content:e}))}}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
        
    )
}

export default WebGoodsOrderEdit